import { EMCType } from '../enums/emc-type';
import { Purpose } from '../enums/purpose';
import { Filter } from './dynamic-filter.model';
import { CimClass } from './network-structure.model';
import { AttributeDefinition } from './section-definition.model';

export class EmcOptions {
  id: number = 0;
  attributeDefinition?: AttributeDefinition;
  attributeDefinitionId: number | null = 0;
  labelName: string = '';
  displayOrder: number = 0;
  isSelected: boolean = false;
  staticPropertyName: string = '';
  additionalStatsInfo: AdditionalStatsInfo | null = null;
}

export class DynamicStats {

  constructor(metadataItem?: EmcOptions, filter?: Filter) {
   metadataItem ? this.metadataItem = metadataItem : null;
   filter ? this.filter = filter : null;
  }

  metadataItem : EmcOptions = new EmcOptions();
  filter : Filter = new Filter();
}

export class AdditionalStatsInfo {
  propertyName: string = '';
  optionIds: number[] = [];
}

export class MetaDataItemDataIn {
  attributeDefinitionId: number | null = 0;
  labelName: string | null = '';
  displayOrder: number = 0;
  staticPropertyName: string | null = '';
  purpose!: Purpose;
  additionalStatsInfo: AdditionalStatsInfo | null = null;
}

export class EmcDataIn {
  entityType!: EMCType;
  metaDataItems: MetaDataItemDataIn[] = [];
  utilityId: number = 0;
  purpose!: Purpose;
  substationTemplateId?: number;
  cimClass?: CimClass;
}
